const COMMENTS = [
  { name: '格斗迷小王', text: '找了很久刃牙漫画免费全集，终于在这里找到了！画质超清晰，下拉式阅读体验太爽了，一晚上刷完了整个死囚篇。强烈推荐给所有刃牙粉！', time: '3天前' },
  { name: '热血漫爱好者', text: '不用注册不用充钱就能看完整刃牙漫画，良心网站！范马勇次郎VS刃牙那段看得我热血沸腾，收藏了每天来看有没有更新。', time: '1周前' },
  { name: '漫画收藏家阿凯', text: '刃牙漫画免费阅读做得最好的站，全部系列都有，从第一部到相扑道全收录。手机上看也很清楚，通勤路上追漫神器。', time: '2周前' },
  { name: '地表最强读者', text: '作为刃牙十年老粉，这个站让我重温了所有经典战役。宫本武藏篇每次看都燃到不行，下拉式翻页比翻实体书还方便！', time: '3周前' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          读者热评
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center mb-10">
          看看其他刃牙漫画读者怎么说
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {COMMENTS.map((c) => (
            <div key={c.name} className="bg-background-50 border border-background-200/80 rounded-xl p-4 md:p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-700 font-bold text-sm">{c.name[0]}</span>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{c.name}</h3>
                  <span className="text-xs text-foreground-500">{c.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {c.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}